export const LocationSection = ({ formData, update }) => (
  <div className="glass-card p-6 space-y-6">
    <h2 className="text-xl text-[#EDEDED] mb-4">Location</h2>
    <div className="grid grid-cols-3 gap-4">
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">City *</label>
        <input
          type="text"
          value={formData.location_city}
          onChange={(e) => update({ location_city: e.target.value })}
          className="input-minimal"
          required
        />
      </div>
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">State *</label>
        <input
          type="text"
          value={formData.location_state}
          onChange={(e) => update({ location_state: e.target.value })}
          className="input-minimal"
          required
        />
      </div>
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">ZIP Code</label>
        <input
          type="text"
          value={formData.location_zip}
          onChange={(e) => update({ location_zip: e.target.value })}
          className="input-minimal"
        />
      </div>
    </div>
  </div>
);
